// ajax 配合JQ3 引入設置
$(document).ready(function () {
  $.ajax({ url: "ajax/_header.html", method: "GET", dataType: "html" }).done(
    function (data) {
      $("#header").html(data);
    }
  );
  $("#footer").load("ajax/_footer.html");
  $("#top-btn").load("ajax/_top-btn.html");
});

function toolsListener() {
  window.addEventListener("keydown", function (e) {
    if (e.keyCode === 9) {
      document.body.classList.remove("js-useMouse");
      document.body.classList.add("js-useKeyboard");
    }
  });
  window.addEventListener("mousedown", function (e) {
    document.body.classList.remove("js-useKeyboard");
    document.body.classList.add("js-useMouse");
  });
}

//呼叫function-網頁載入完成後
$(document).ready(function () {
  toolsListener();
});
//呼叫function-視窗大小變更
$(window).resize(function () {});
//呼叫function-捲動
$(window).scroll(function () {});
//==================以上 blueprint 代碼====================
